// extracted by mini-css-extract-plugin
export var copyableField = "_rs-4";
export var customerBadge = "_rs-0";
export var customerInfoTitle = "_rs-2";
export var details = "_rs-1";
export var dropdownContainer = "_rs-5";
export var dropdownImage = "_rs-6";
export var editAssigneeForm = "_rs-a";
export var editButton = "_rs-3";
export var email = "_rs-7";
export var hidden = "_rs-d";
export var input = "_rs-8";
export var saveButton = "_rs-b";
export var shopifyIcon = "_rs-c";
export var suggestionBadge = "_rs-e";
export var suggestionText = "_rs-f";
export var username = "_rs-9";